import { DocumentConnection } from '../../common/model/document-connection-base';
import { PropertyDocumentType, PropertyDocumentTypeToString } from './const/documentEnums';

export class PropertyDocument extends DocumentConnection<PropertyDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return PropertyDocumentTypeToString(this.connectionType);
  }

  contact: string;

  toJSON() {
    var result = super.toJSON();
    result['property'] = this.contact;
    return result;
  }
}
